export const APIS = {
  LOGIN_AZURE: '/api/Account/LoginAzureCallback',
  POSTS: '/posts',
  REQUESTS: '/api/Request/Search',
  ALL_REQUESTS: '/api/Request/SearchInRequestTab',
  USER_MANAGEMENT: '/api/User/GetListAllUser',
  STATISTIC: '/api/Request/Statistic',
  NOTIFICATION_SEARCH: '/api/SAP/GetSapEcc6',
  MAINTENANCE_SEARCH: '/api/SAP/GetSapEcc6ByMONumber',
  SCAFFOLD_SEARCH: '/api/Request/SearchScaffoldDetailByScaffoldID',
  STEEL_SEARCH: '/api/Request/SearchScaffoldDetailBySteelID',
  SYNC_SCAFFOLD: '/api/Request/SyncScaffoldDetail',
  EXPORT_DATA_REQUEST: '/api/ExportData/Request',
  SCAFFOLD_COUNT: '/api/Request/GetScaffoldCount',

  CREATE_INSULATION_REQUEST: '/api/Insulation/CreateRequest',
  META_DATA_REQUESTOR_DETAIL: '/api/MetaData/GetRequestorDetail',
  META_DATA_INSULATION_DETAIL: '/api/MetaData/GetInsulationDetail',
  META_DATA_PROPOSAL_DETAIL: '/api/MetaData/GetInsulationProposal',
  META_DATA_PRIORITY: '/api/MetaData/GetInsulationWorkDetail',
  EDIT_INSULATION_REQUEST: '/api/Insulation/EditRequest',
  SEARCH_LOCATION: '/api/Insulation/SearchFunctionalLocation',
  REMOVAL_SEARCH_LEADER_NAME: '/api/User/GetLeaderName',
  SEARCH_LOCATION_BY_ID: 'api/Insulation/GetFunctionalLocationById',

  //InsulationProposal
  PROPOSAL_INFOR: '/api/getProposalInfo',
  SUBMIT_INSULATION_PROPOSAL:
    '/api/InsulationProposal/SubmitInsulationProposal',
  SAVE_INSULATION_PROPOSAL: '/api/InsulationProposal/SaveInsulationProposal',
  INSULATION_REJECTED: '/api/InsulationProposal/RejectProposal',

  //PaintingProposal
  PROPOSAL_SUBMIT: '/api/Painting/SubmitProposal',
  PROPOSAL_REJECT: '/api/Painting/RejectProposal',

  //InsulationBilling
  BILLING_SUBMIT: '/api/Insulation/BillingSubmit',

  //Inservice
  EDIT_INSULATION_INSERVICE_REQUEST: '/api/Insulation/EditRequestInService',

  //PaintingBilling
  PAINTING_BILLING: '/api/Painting/Billing',

  //InsulationDetail
  SUBMIT_INSULATION_DETAIL: '/api/Insulation/AssignContractor',
  REJECT_INSULATION_DETAIL: '/api/Insulation/RejectRequest',

  //painting
  CREATE_PAINTING_REQUEST: '/api/Painting/CreateRequest',
  META_DATA_QAQC_DETAIL: '/api/MetaData/QaqcDetail',
  CREATE_PAINTING_DETAIL: '/api/Insulation/CreatePaintingDetail',
  CREATE_VALIDATION_PAINTING_DETAIL: '/api/Painting/RequestValidation',
  META_DATA_PAINTING_DETAIL: '/api/MetaData/GetPaintingDetail',
  META_DATA_VALIDATION_PAINTING: '/api/MetaData/GetPaintingRequestValidation',
  SEARCH_SERVICE_PROVIDER: '/api/Request/GetServiceProviderName',
  SEARCH_INSPECTOR_NAME: '/api/Request/GetInspectorName',
  SEARCH_LEADER_NAME: '/api/Request/GetLeaderName',
  REJECT_PAINTING_REQUEST: '/api/Painting/RejectRequest',
  EDIT_PAINTING_REQUEST: '/api/Painting/EditRequest',
  GET_PAINTING_WORK_DETAIL: '/api/MetaData/GetPaintingWorkDetail',

  //PaintingWorkDetail
  PAINTING_WORK_DETAIL: '/api/Painting/PaintingWorkDetail',

  //PTW
  SUBMIT_REINSTATEMENT_PTW: '/api/PTW/SubmitReinstatementPTW',
  SUBMIT_REMOVAL_PTW: '/api/PTW/SubmitRemovalPTW',
  GET_TOKEN_PTW: '/api/PTW/GetToken',
  PTW_CANCEL_PROPOSAL: '/api/PTW/CancelProposal',

  //ServiceProvider
  ADD_SERVICES_PROVIDER: '/api/ServicesProvider/AddServicesProvider',
  UPDATE_SERVICES_PROVIDER: '/api/ServicesProvider/UpdateServiceProvider',
  SEARCH_SERVICES_PROVIDER: '/api/ServicesProvider/Search',
  DELETE_SERVICES_PROVIDER: '/api/ServicesProvider/DeleteServicesProvider',

  USER_INFOR: '/api/getUserInfo',
  INSULATION_DATA: 'api/insulationData',
  FETCH_REQUEST_BY_ID: '/api/Insulation/GetInsulationRequest',
  FETCH_REQUEST_BY_CUSTOM_ID: '/api/Insulation/GetInsulationRequestByCustomId',

  UPLOADED_FILE: '/api/upload',

  REMOVAL_COMPLETION_SUBMIT: '/api/Insulation/SubmitRemovalChecklist',

  REINSTATEMENT_COMPLETION: '/api/Insulation/SubmitReinstatementCompletion',
  REINSTATEMENT_SEARCH_LEADER_NAME: '/api/Request/GetLeaderName',
  QAQC_SEARCH_USER: '/api/Painting/SearchAllUserOrContractor',
  QAQC_PAINTING_SUBMIT: '/api/Painting/SubmitAndValidateQAQC',
  QAQC_GET_LIST: '/api/Painting/GetListQAQC',
  QAQC_GET_SUBMIT_TIME: '/api/Painting/GetSubmittedQAQCsTime',
  REJECT_REQUEST: '/api/Request/Reject',
  SENDBACK_REQUEST: '/api/Insulation/SendBackRequest',
  SENDBACK_REQUEST_CONTRACTOR: '/api/Painting/SendBackRequestForContractor',
  SENDBACK_REQUEST_CONTRACTOR_QAQC: '/api/Painting/SendBackRequestForQAQC',
  SENDBACK_REQUEST_ADMIN: '/api/Painting/SendBackRequestForAdmin',
  CANCELD_REQUEST: '/api/Insulation/CancelRequest',
  COMPLETE_REQUEST: '/api/Insulation/ConfirmWorkCompleted',
  CLOSE_REQUEST: '/api/Insulation/BillingQuickClose',
  REINSTATEMENT_CHECKLIST: '/api/Insulation/SubmitReinstatementChecklist',

  PAINTING_GET_REQUEST: '/api/Painting/GetRequest',
  PAINTING_GET_REQUEST_BY_CUSTOM_ID: '/api/Painting/GetRequestByCustomId',
  UPLOAD_FILE_TO_AZURE: '/api/InsulationProposal/UploadFileToAzure',
  DOWNLOAD_FILE_FROM_AZURE: '/api/DownloadFile/DownloadFile',
  ACTIVITY_LOG: '/api/Request/GetActivityLog',

  AZURE_AD_USER: '/api/AzureAdUser/Filter',
  META_DATA_USER_COMPANY: '/api/MetaData/GetUserSearch',
  CREATE_USER: '/api/User/AddUser',
  EDIT_USER: '/api/User/UpdateUser',
  DELETE_USER: '/api/User/DeleteUser',
};

export const ENDPOINTS = {
  MICROSOFT_GRAPH_BASE_URL: 'https://graph.microsoft.com',
};
